const myccBaseUrl = process.env.NEXT_PUBLIC_MYCC_BASE_URL;

export const getAppLinks = () => {
  // Note that NODE_ENV of 'development' only refers to local development. It doesn't refer to dev deploy environments which use 'production' builds
  return process.env.NODE_ENV === 'production'
    ? ({
        mode: 'STATIC_SITE',
        businessEmissions: 'business-emissions.html', // note: no preceeding '/'
        calculatorWidget: 'calculator-widget.html', // note: no preceeding '/'
        carbonClickBusinessEmissionsUrl: `${myccBaseUrl}my-cc/business-calculator`, // this URL also expects params of ?business&merchantReferrerCode=XXX&industry=XXX&numberOfEmployees=n
        carbonClickDashboardUrl: `${myccBaseUrl}my-cc`,
        carbonClickPaymentsUrl: `${myccBaseUrl}my-cc/payment`, // this URL also expects params of ?business&merchantReferrerCode=XXX&industry=XXX&numberOfEmployees=n
      } as const)
    : ({
        mode: 'DEV',
        businessEmissions: '/business-emissions', // note: has preceeding '/'
        calculatorWidget: '/calculator-widget', // note: has preceeding '/'
        carbonClickBusinessEmissionsUrl: '/reference2.html',
        carbonClickDashboardUrl: '/reference2.html',
        carbonClickPaymentsUrl:
          myccBaseUrl === '/'
            ? `${myccBaseUrl}my-cc/payment`
            : '/reference2.html',
      } as const);
};
